import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { Router } from '@angular/router';
import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { Swiper } from 'swiper';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DatePipe, ViewportScroller } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import 'lightslider';
import { loadStripe, Stripe, StripeCardElement, StripeElements } from '@stripe/stripe-js';
const countryData = require('../country-code.json');
declare var $: any;

@Component({
    selector: 'app-package-details',
    templateUrl: './package-details.component.html',
    styleUrls: ['./package-details.component.css']
})
export class PackageDetailsComponent implements OnInit, AfterViewInit {
    PlaceId: string = '';
    countries: any[] = [];
    isUpdate: boolean = false;
    overviewDataList: any = [];
    itineraryDataList: any = [];
    // policyDataList: any = [];
    vehicleDataList: any = [];
    vehicleDataListByPlace: any = [];
    hotelDataList: any = [];
    hotelDataListByPlace: any = [];
    roomsDataListByHotel: any = [];
    selectedHotel: any;
    tempSelectedHotel: any;
    selectedvehicle: any;
    stars = [1, 2, 3, 4, 5];
    activityDataList: any = [];
    bookingPackageDataList: any[] = [];
    selectedActivityList: any[] = [];
    defaultPackageHVAData: any[] = [];
    popUpImages: any[] = [];
    cities: any = [];
    dropdownStates: boolean[] = [true];
    userId: any;
    currentSection: string = 'overview';
    packageId;
    bookingId = null;
    bookingNo = null;
    packageDays: number = 0;
    tempActivityDay: any;
    currentDate: Date = new Date();
    // selectedStartDate: any | null = null;
    selectedEndDate: any | null = null;
    bookingFormSubmitted: boolean = false;
    isImgLoading: boolean = true;
    showFullText = false;
    isContentLong = false;
    acknowledged = false;
    isInquiry = false;
    totalPerson: number = 0;
    adults: number = 0;
    children: number = 0;
    updatedPrice: number;
    totalPackagePrice: number;
    defaultAminitiesPath: string = 'uploads/Amenities/Default.png';
    formattedCancellationDate: string = '';
    openedOffcanvas: string = '';

    // packagePriceTax: number;
    rooms: any[] = [];
    selectedRoomIndex = 0;
    activeItineraryIndex = 0;
    @ViewChild('contentRef') contentRef!: ElementRef;
    selectableDatesSet: Set<string> = new Set();

    calendarBody: HTMLElement | null = null;
    monthYear: HTMLElement | null = null;
    bookingForm: FormGroup;

    selectedDateIndex: number;
    months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Simulated data response
    monthData: any = [];
    cancellationAvailable: boolean = true;
    selectedMonth: string;
    availableDates: { startDate: string, endDate: string }[] = [];


    selectedStartDate: Date | null = null; // User-selected start date
    cancellationDaysBefore: number = 0; // Days allowed for cancellation (from API)
    cancellationCharge: number = 0; // Cancellation fee percentage (from API)
    cancellationDeadline: Date | null = null; // Calculated deadline for cancellation
    policyDataList: any[] = []; // Holds policy data fetched from the API

    cancellationPolicy: any = []
    termsAndConditionPolicy: any = []

    formattedCancellationDeadline: string = '';
    formattedAfterDeadline: string = '';
    cancellationFee: number = 0;
    isNonRefundableZero: boolean;
    cancellationPolicies: any[];
    hasCancellationData: boolean;
    minStartDate: Date = this.getISTDate();
    datePickerConfig = {
        isAnimated: true,
        adaptivePosition: true,
        containerClass: 'theme-blue',
        rangeInputFormat: 'MMM DD, YYYY',
        showWeekNumbers: false,
        minDate: this.minStartDate
    };

    // enquire part
    guestUser: boolean;
    contactDetailsForm: FormGroup;
    countryData = countryData;
    useForPrimary: boolean = true;
    travelerInfoSuccess: boolean = false;
    ReviewbookingForm: FormGroup;
    selectedTravelerIndex: number = 0;
    discount: number = 0;
    finalSubTotal: number = 0;
    discountedSubTotal: number = 0;
    discountedTotalPrice: number = 0;
    discountPercentage: number = 0;
    isPercentage: boolean = true;
    promoCodeId: string = '';
    promoCode: string = '';
    promoCodesList: any = [];
    filteredPromoCodesList: any = [];
    filteredActivityDataList: any = [];
    searchTerm: string = '';

    stripe!: Stripe;
    elements!: StripeElements;
    card!: StripeCardElement;
    clientSecret!: string;
    cardDetails: any = null;

    //#region Customize Package
    customInqForm: FormGroup;
    customInqSubmitted = false;
    flightFormVisible: boolean = false;
    tripType_flight: string = 'oneWay';
    noOfPersonError: string;
    citySegments_flight: any[] = [this.createCitySegment()];
    showOtherTextbox = false;
    PlaceList: any = [];
    otherService = '';
    minDate: string;
    minEndDate: any;
    endDateBeforeStartDate: boolean = true;
    //#endregion
    constructor(private router: Router,
        private route: ActivatedRoute,
        public storageService: StorageService,
        public commonService: CommonService,
        private datePipe: DatePipe,
        public userLayoutService: UserLayoutService,
        private fb: FormBuilder,
        private viewportScroller: ViewportScroller,
        private cdRef: ChangeDetectorRef,
        private http: HttpClient,
        private sanitizer: DomSanitizer
    ) {

    }

    async ngOnInit(): Promise<void> {

        this.userId = localStorage.getItem("_id");

        this.guestUser = this.userId === null;

        // this.calendarBody = document.getElementById('days-grid');
        // this.monthYear = document.getElementById('month-year');
        // this.updateCalendar();

        // document.getElementById('prev-month')?.addEventListener('click', () => {
        //     this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        //     this.updateCalendar();
        // });

        // document.getElementById('next-month')?.addEventListener('click', () => {
        //     this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        //     this.updateCalendar();
        // });

        this.overviewDataList = [];
        this.itineraryDataList = [];
        this.policyDataList = [];
        this.route.queryParams.subscribe(params => {
            this.packageId = params['PackageId'];
            // this.bookingId = params['bookingID'];
        });
        const bookingDetails = JSON.parse(localStorage.getItem('bookingDetails') || '{}');

        // Check if placeId matches
        if (bookingDetails.packageId && bookingDetails.packageId === this.packageId) {
            // Set bookingId to the matched bookingId value
            this.bookingId = bookingDetails.bookingId;
        }
        const currentMonthIndex = new Date().getMonth();
        // this.selectedMonth = this.months[currentMonthIndex];
        this.isUpdate = this.bookingId === null || this.bookingId === undefined;
        this.addRoom();
        this.getOverviewDataPlaceData();
        this.getItineraryDataPlaceData();
        this.getPolicyDataPlaceId();
        this.defaultContactDetailsForm();
        this.defaultBookingForm();
        this.getCityListById();
        // this.getAvailableDatesOfPackageById();
        this.defaultBookingForm();
        // this.defaultReviewBookingForm();
        this.fetchCountries();
        this.activityDataList.forEach(activity => {
            activity.activityTraveller = (this.totalTravellers + this.totalBabyChild);
        });
        this.stripe = await loadStripe(this.commonService.stripePublishKey);

        // Create Stripe Elements
        this.elements = this.stripe.elements();

        const cardOptions = {
            style: {
                base: {
                    fontSize: '16px',
                    color: '#32325d',
                    lineHeight: '24px',
                    letterSpacing: '0.025em',
                    fontFamily: 'Arial, sans-serif',
                    iconColor: '#c4f0ff',
                    '::placeholder': {
                        color: '#aab7c4',
                    },
                },
            },
            hidePostalCode: true, // Hide the ZIP code field
        };
        // Create a card element
        this.card = this.elements.create('card', cardOptions);
        this.card.mount('#card-element');

        this.card.on('change', (event) => {
            const displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError!.textContent = event.error.message;
            } else {
                displayError!.textContent = '';
            }
        });

        setTimeout(() => {
            this.calculateDiscountedPrice();
        }, 500);
        // $("#proceedToPayment").modal('show');
        this.getPlaceListData()
        this.defaultAddCustomInqForm()
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            // Itinerary content toggle
            $(document).off('click', '.itineraryitem_header').on('click', '.itineraryitem_header', function () {
                const $currentItem = $(this).closest('.itineryitem');
                const isActive = $currentItem.hasClass('active');

                var scrollTo = $currentItem.offset().top - ($(window).height() / 2) + ($currentItem.outerHeight() / 2);
                // Animate scroll to the top of the activated item
                $('html, body').animate({
                    scrollTop: scrollTo
                }, 100);
            });
        }, 0); // Delay to ensure Angular has rendered the DOM
        setInterval(() => {
            // Itinerary and summery selector
            $('.itinerary_and_summary_selector li').click(function () {
                $('.itinerary_and_summary_selector li').removeClass('active');
                $(this).addClass('active');
            });

            // add section
            $('.addscloseicon').click(function () {
                $('.adds_section').css('right', '-100%');
                $('.open_add_section').css({
                    'right': '0',
                    'delay': '0.5s',
                });

            });
            $('.enquire_btn').click(function () {

                if ($('.adds_section').css('right') === '0px') {
                    $('.adds_section').css('right', '-100%');
                    $('.open_add_section').css({
                        'right': '0',
                        'delay': '0.5s',
                    });
                }

            });
            $('.open_add_section').click(function () {
                $('.adds_section').css({

                    'right': '0',
                    'transition': 'all 0.5s ease',
                    'delay': '0.5s',
                });
                $('.open_add_section').css({
                    'right': '-100%',
                    'delay': '0.5s',
                });

            });

            $('.itinerarybtn').click(function () {
                $('.itinerary_list_area').fadeIn();
                $('.summery_items_area').fadeOut();
            });
            $('.summarybtn').click(function () {
                $('.itinerary_list_area').fadeOut();
                $('.summery_items_area').fadeIn();
            });
            $('.prevbtn').click(function () {
                $('.itinerary_list_area').fadeIn();
                $('.summery_items_area').fadeOut();
                $('.itinerarybtn').addClass('active');
                $('.summarybtn').removeClass('active');
            });
            $('.nextbtn').click(function () {
                $('.itinerary_list_area').fadeOut();
                $('.summery_items_area').fadeIn();
                $('.summarybtn').addClass('active');
                $('.itinerarybtn').removeClass('active');

            });



            // traveler details area
            $('.traveler_details_area ul li button').click(function () {
                $('.traveler_details_area ul li').removeClass('active');
                $(this).closest('li').addClass('active');

            });


            // hotel details popup
            $('#hotelDetailsshow').click(function () {
                $('.overlay').fadeIn();
                $('.hotel_details_popup').css({
                    'right': '0',
                    'transition': 'all 0.5s ease',
                });
            });
            $('.hotelDetailsClose').click(function () {
                $('.overlay').fadeOut();
                $('.hotel_details_popup').css({
                    'right': '-100%',
                    'transition': 'all 0.5s ease',
                });
            });

            $('.expendedimageclose').click(function () {
                $('.hotelImagefull_screen').fadeOut();
                $('.hotel_details_popup').css({
                    'right': '0',
                    'transition': 'all 0.5s ease',
                });

            });
            // $('.selectbtn').click(function () {
            //     $(this).toggleClass('active');

            // });

            // add activity
            $('.addActivities').click(function () {
                $('.overlay').fadeIn();
                $('.add_activity_area').css({
                    'right': '0',
                    'transition': 'all 0.5s ease',
                });
            });
            $('.addActivityClose').click(function () {
                $('.overlay').fadeOut();
                $('.add_activity_area').css({
                    'right': '-100%',
                    'transition': 'all 0.5s ease',
                });
            });
            $('.addPromoClose').click(function () {
                $('.overlay').fadeOut();
                $('.add_promo_area').css({
                    'right': '-100%',
                    'transition': 'all 0.5s ease',
                });
            });

            // expand image slider
            $(document).on('click', '.expendedbtn', function () {
                // Open your modal/popup
                $('.hotelImagefull_screen').show();

                // Animate .add_activity_area to move right
                $('.hotel_details_popup').css({
                    'right': '-100%',  // Move it out of view to the right
                    'transition': 'all 0.5s ease',  // Apply smooth transition
                });

                // Initialize Slick slider after the popup is visible
                setTimeout(function () {
                    // Initialize slick slider for the images
                    $('.hotel_image_slider').slick({
                        dots: false,
                        infinite: true,
                        speed: 500,
                        fade: false,
                        cssEase: 'linear'
                    });
                }, 100); // Delay to ensure the popup is fully visible

            });
            // expand image slider
            $(document).on('click', '.allcarImageshow', function () {
                $('#expendCarImage').show();
                setTimeout(function () {
                    // Initialize slick slider for the images
                    $('.car_image_slider').slick({
                        dots: false,
                        infinite: true,
                        speed: 500,
                        fade: false,
                        cssEase: 'linear'
                    });
                }, 100); // Delay to ensure the popup is fully visible


            });

        }, 200);
    }


    initializeHotelImageSlider() {
        setTimeout(() => {
            $('.itinerary-hotel-slick-slider').slick({
                lazyLoad: 'ondemand',
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: true,
            });
        }, 0);
    }

    openHotelImagePopup(images: any, offcanvas: any) {
        // Step 1: Normalize image list if it has a "path" property
        if (images[0]?.path) {
            images = images.map((img: any) => img.path);
        }

        // Step 2: Set popup images
        this.popUpImages = [...(images || [])];
        this.isImgLoading = true;

        // Step 3: Hide any open offcanvas if needed
        if (offcanvas) {
            this.openedOffcanvas = offcanvas;
            $(`#${this.openedOffcanvas}`).offcanvas('hide');
        } else {
            this.openedOffcanvas = '';
        }

        // Step 7: Show the modal popup       
        $("#imagesModal").modal('show');
        setTimeout(() => {

            // Step 4: Wait a bit for modal to open and DOM to render
            const $existingSlider = $('.images-popup-slick-slider');

            // Step 5: Destroy existing lightSlider instance if exists
            if ($existingSlider.data('lightSlider')) {
                $existingSlider.data('lightSlider').destroy(true); // true to remove DOM changes
            }

            // Step 6: Clear the existing slider DOM and recreate it manually
            const sliderHTML = `
        <ul class="images-popup-slick-slider">
          ${this.popUpImages.map(image => `
            <li data-thumb="${this.commonService.rootData.rootFilePath + image}">
              <img src="${this.commonService.rootData.rootFilePath + image}"
                   style="height: 400px; border-radius: 15px;"
                   onerror="this.src='fallback.jpg'" />
            </li>
          `).join('')}
        </ul>
      `;

            $('#slider-wrapper').html(sliderHTML);

            // Step 8: Initialize lightSlider again
            $('.images-popup-slick-slider').lightSlider({
                gallery: true,
                item: 1,
                loop: true,
                thumbItem: 9,
                slideMove: 1,
                speed: 600,
                controls: true,
                adaptiveHeight: true
            });

            this.isImgLoading = false;
        }, 300);
    }


    openSingleImagePopup(image: any, offcanvas: any) {
        this.popUpImages = [];
        this.popUpImages.push(image);
        if (offcanvas) {
            this.openedOffcanvas = '';
            this.openedOffcanvas = offcanvas;
            $(`#${this.openedOffcanvas}`).offcanvas('hide');
        } else {
            this.openedOffcanvas = '';
        }
        $("#imageModal").modal('show');
    }

    closeImagePopup() {
        $(`#${this.openedOffcanvas}`).offcanvas('show');
        this.openedOffcanvas = '';
    }

    fetchCountries() {
        this.http.get<any[]>('https://restcountries.com/v3.1/all').subscribe(
            (data) => {
                this.countries = data.map((country) => {
                    return {
                        name: country.name.common,
                        dialCode: `${country.idd?.root}${country.idd?.suffixes ? country.idd.suffixes[0] : ''}`,
                        flag: country.flags.png,
                    };
                });
            },
            (error) => {
            }
        );
    }

    searchByName(term: string, item: any) {
        return item.name.toLowerCase().includes(term.toLowerCase());
    }

    integerConvert(rating: any): number[] {
        const parsedRating = parseInt(rating, 10);
        return isNaN(parsedRating) || parsedRating <= 0 ? [] : Array(parsedRating).fill(0);
    }

    remainingStars(rating: number): any[] {
        return Array(5 - Math.floor(rating));
    }

    defaultBookingForm() {
        this.bookingForm = this.fb.group({
            arrivalCity: ['', Validators.required],
        });
        if (!this.isUpdate) {
            this.userLayoutService.getBookingDetailsByBookingId(this.bookingId).subscribe((Response: any) => {

                if (Response.code == 1) {
                    const data = Response.data;
                    this.bookingForm.patchValue({
                        arrivalCity: data.arrivalCity,
                    });
                    this.rooms = data.roomDeatils;
                    this.updatedPrice = data.perPersonPrice;
                    const startDate = new Date(data.startDate);
                    const monthName = startDate.toLocaleString('default', { month: 'long' });
                    data.startDate = new Date(data.startDate);
                    data.endDate = new Date(data.endDate);
                    this.selectedStartDate = data.startDate;
                    this.selectedEndDate = data.endDate;

                }
                else {
                }
            }, (error) => {
            });

        }
        this.bookingFormSubmitted = false;
    }

    defaultContactDetailsForm() {
        this.contactDetailsForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, this.customEmailValidator()]],
            countryCode: ['+1', Validators.required],
            contactNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
        });
        this.bookingFormSubmitted = false;
    }

    customEmailValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const isValidEmail = emailPattern.test(control.value);
            return isValidEmail ? null : { 'invalidEmail': true };
        };
    }

    mobilenumberInput(event: any, formName: string, controlName: string): void {
        const input = event.target;

        // Allow only numeric values (0-9)
        input.value = input.value.replace(/[^0-9]/g, '');

        // Update the form control value
        this[formName].patchValue({
            [controlName]: input.value || null,
        });
    }

    trimWhitespace(event: any): void {
        const input = event.target;
        input.value = input.value.replace(/\s+/g, '');
    }


    selectDate(index: number): void {
        this.selectedDateIndex = index;

        // Get selected start date from the available dates
        const selectedStartDate = this.availableDates[index].startDate;
        const parsedStartDate = new Date(selectedStartDate);

        this.selectedStartDate = parsedStartDate;

        // Set the selected end date based on package duration
        this.selectedEndDate = new Date(parsedStartDate);
        this.selectedEndDate.setDate(parsedStartDate.getDate() + this.packageDays - 1);

        // Calculate the cancellation deadline (subtracting policy days)
        this.cancellationDeadline = new Date(parsedStartDate);
        this.cancellationDeadline.setDate(
            this.cancellationDeadline.getDate() - this.cancellationDaysBefore
        );

        // Calculate the number of days from today to the selected start date
        const today = new Date();
        const timeDifference = parsedStartDate.getTime() - today.getTime();
        const daysUntilPackageStart = Math.floor(timeDifference / (1000 * 3600 * 24));

        // Check if cancellation is allowed
        if (today > this.cancellationDeadline || daysUntilPackageStart < this.cancellationDaysBefore) {
            this.cancellationAvailable = false;
        } else {
            this.cancellationAvailable = true;
        }

        // Format dates for display
        this.formattedCancellationDeadline = this.cancellationDeadline.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });

        // Properly set formattedAfterDeadline to the cancellation deadline
        this.formattedAfterDeadline = this.cancellationDeadline.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });

    }


    isSameDay(Day: number, itineraryDays: string): boolean {
        return Day === parseInt(itineraryDays, 10);
    }


    openMap(lat: number, long: number): void {
        const googleMapsUrl = `https://www.google.com/maps?q=${lat},${long}`;
        window.open(googleMapsUrl, '_blank');
    }

    roundedPricePerPerson(hotelRoomPrice, defaultRoomPrice): number {
        const difference = (hotelRoomPrice - defaultRoomPrice) || 0;
        const total = (difference * this.rooms.length);
        return Math.round(total);
    }

    roundedPricePerPersonVehicle(vehiclePrice, vehicleSeater): number {
        // console.log(vehiclePrice, defaultVehiclePrice, vehicleSeater, totalCars);

        const difference = (vehiclePrice - this.defaultPackageHVAData[this.tempActivityDay - 1]?.selectedVehicle[0]?.vehicleFinalPrice) || 0;
        const carsRequired = Math.ceil(this.totalTravellers / parseInt(vehicleSeater));
        const cars = Math.ceil(this.totalTravellers / parseInt(this.defaultPackageHVAData[this.tempActivityDay - 1]?.selectedVehicle[0]?.carSeaterAc));
        let total;
        if (cars == carsRequired) {
            total = (difference * carsRequired);
        } else {
            total = (difference * carsRequired) * cars;
        }
        return Math.round(total);

    }

    get packagePriceTax(): number {

        const taxRate = this.commonService.taxRatio;
        const taxAmount = this.discountedSubTotal * taxRate;
        const packageTaxPrice = Math.round(taxAmount * 100) / 100;
        return (packageTaxPrice);
    }

    get subTotalPrice(): number {
        let subtotal = 0;
        let totalPersons = 0;
        let selectedPrice = 0;
        let totalHotelPrice = 0;
        let rooms = 0;


        this.rooms.forEach((room) => {
            totalPersons += room.adults + room.children;
            rooms += 1;
        });

        this.selectedActivityList.forEach((day) => {
            day.selectedHotel?.forEach((hotel) => {
                totalHotelPrice += hotel.roomPrice;
            });
        });
        let additionalHotelprice = 0;
        if (rooms > 1) {
            additionalHotelprice = totalHotelPrice * (rooms - 1);
        }
        let additionalRoomPrice = 0;
        this.rooms.forEach((room) => {
            if (room.adults > 2) {
                additionalRoomPrice += ((room.adults - 2) * ((totalHotelPrice * this.overviewDataList.extraAdultsPercentage) / 100));
            } else if (room.adults < 2 && room.children > 1) {
                additionalRoomPrice += ((room.children - 1) * ((totalHotelPrice * this.overviewDataList.extraChildsPercentage) / 100));
            }

            if (room.adults > 1 && room.children > 0) {
                additionalRoomPrice += (room.children * ((totalHotelPrice * this.overviewDataList.extraChildsPercentage) / 100));
            }
            Math.round(additionalRoomPrice);
        });
        selectedPrice = this.overviewDataList.discountedPrice + additionalRoomPrice + additionalHotelprice;
        subtotal = selectedPrice || 0;

        let activityTotal = 0;

        this.selectedActivityList.forEach((day) => {
            day.activities.forEach((activity) => {
                if (activity.activityTraveller > 0) {
                    activityTotal += activity.activityTraveller * parseInt(activity.discountPrice);
                }
            });
        });

        subtotal += activityTotal;

        return subtotal;
    }

    get totalTravellers(): number {
        return (this.totalAdults + this.totalChildren);
    }

    get totalAdults(): number {
        return this.rooms.reduce((sum, room) => sum + room.adults, 0);
    }

    get totalChildren(): number {
        return this.rooms.reduce((sum, room) => sum + room.children, 0);
    }

    get totalBabyChild(): number {
        return this.rooms.reduce((sum, room) => sum + room.child, 0);
    }

    addRoom(): void {
        const newRoom = { room: this.rooms.length + 1, adults: 2, children: 0, child: 0 };
        this.rooms.push(newRoom);
        this.selectedRoomIndex = this.rooms.length - 1;

    }


    selectRoom(index: number) {
        this.selectedRoomIndex = index;
    }

    removeRoom(index: number): void {
        if (this.rooms.length > 1) {
            this.rooms.splice(index, 1);
            this.updateRoomNumbers();
            if (index === this.selectedRoomIndex) {
                this.selectRoom(0)
            } else {
                if (this.selectedRoomIndex == 0) {
                    this.selectRoom(0);
                } else {
                    this.selectedRoomIndex -= 1;
                }
            }
        }
    }

    increaseCount(index: number, category: string): void {
        const totalPersons = this.totalAdults + this.totalChildren + this.totalBabyChild;

        const room = this.rooms[index];
        let roomPersons = room.adults + room.children + room.child;
        let maxAvailability = room.adults + room.children;
        if (category === 'adults') {
            if (room.adults < 3 && maxAvailability < 3) {
                room.adults++;
            } else {
                this.commonService.notifier.notify('warning', 'You have reached the maximum limit in this room.');
                this.addRoom();
                this.rooms[this.rooms.length - 1].adults = 1;
            }
        } else if (category === 'children') {
            if (room.children < 2 && maxAvailability < 3) {
                room.children++;
            } else {
                this.commonService.notifier.notify('warning', 'You have reached the maximum limit in this room.');
            }
        } else if (category === 'child') {
            if (room.child < 2 && roomPersons < 4) {
                room.child++;
            } else {
                this.commonService.notifier.notify('warning', 'You have reached the maximum limit in this room.');
            }
        }

        this.updatePrice();
    }


    updatePrice(): void {
        this.subTotalPrice;
    }



    decreaseCount(index: number, category: string): void {
        const room = this.rooms[index];

        if (category === 'adults' && room.adults > 1) {
            room.adults--;
        } else if (category === 'children' && room.children > 0) {
            room.children--;
        } else if (category === 'child' && room.child > 0) {
            room.child--;
        }
    }


    increaseActivity(index: number, isSelected: boolean): void {
        if (this.activityDataList[index].activityTraveller < (this.totalTravellers + this.totalBabyChild)) {
            this.activityDataList[index].activityTraveller += 1;
            this.selectedActivityList[this.tempActivityDay - 1].activities.forEach(activity => {
                if (this.activityDataList[index].activityID === activity.activityID) {
                    activity.activityTraveller = this.activityDataList[index].activityTraveller;
                }
            });
            if (!isSelected) {
                this.updatedPrice += (parseInt(this.activityDataList[index].discountPrice) / (this.totalTravellers + this.totalBabyChild));
            }
        }
    }

    decreaseActivity(index: number, isSelected: boolean): void {
        if (this.activityDataList[index].activityTraveller > 1) {
            this.activityDataList[index].activityTraveller -= 1;
            this.selectedActivityList[this.tempActivityDay - 1].activities.forEach(activity => {
                if (this.activityDataList[index].activityID === activity.activityID) {
                    activity.activityTraveller = this.activityDataList[index].activityTraveller;
                }
            });
            if (!isSelected) {
                this.updatedPrice -= (parseInt(this.activityDataList[index].discountPrice) / (this.totalTravellers + this.totalBabyChild));
            }
        }
    }



    adjustChildren(index: number): void {
        const room = this.rooms[index];
        const maxChildren = 4 - room.adults;

        if (room.children > maxChildren) {
            room.children = maxChildren;
        }
    }

    adjustAdults(index: number): void {
        const room = this.rooms[index];
        const maxAdults = 4 - room.children;

        if (room.adults > maxAdults) {
            room.adults = maxAdults;
        }
    }

    updateRoomNumbers(): void {
        this.rooms.forEach((room, index) => {
            room.room = index + 1;
        });
    }

    getOverviewDataPlaceData() {
        let dataObj = {
            packageId: this.packageId
        }
        this.userLayoutService.getOverviewDataByPlaceId(dataObj).subscribe((Response: any) => {

            if (Response.code == 1) {

                // setTimeout(() => {
                this.overviewDataList = Response.data;
                this.updatedPrice = this.overviewDataList.discountedPrice;
                setTimeout(() => {
                    // this.checkContentHeight();
                    $('.slider-nav').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerMode: true,
                        focusOnSelect: true,
                        autoplay: true,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        autoplaySpeed: 2500,
                        // loop: true,
                        responsive: [{
                            breakpoint: 1440,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            }
                        },
                        {

                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    });


                    // Package details hero slider
                    $('.packageDetailsheroslider').slick({
                        prevArrow: $('.details_hero_slider_prev'),
                        nextArrow: $('.details_hero_slider_next'),
                        dots: false,
                        infinite: true,
                        speed: 300,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        arrows: true,
                        autoplay: true,
                        cssEase: "linear",
                        pushOnHover: true,
                        autoplaySpeed: 2000,
                        responsive: [{
                            breakpoint: 1400,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                        ]
                    });



                }, 0.5);
                // }, 1000);
            }
            else {
            }
        }, (error) => {
        });
    }

    getItineraryDataPlaceData() {
        this.userLayoutService.getItineraryDataByPlaceIdNew(this.packageId).subscribe((Response: any) => {

            if (Response.code == 1) {
                this.itineraryDataList = Response.data;
                const totalDropdowns = Response.data.length;
                this.dropdownStates = Array(totalDropdowns).fill(false);
                this.dropdownStates[0] = true;

                let itineraryListItems = this.itineraryDataList;
                this.packageDays = this.itineraryDataList.length;
                // this.getActivityDataPlaceId();
                const bookingDetails = JSON.parse(localStorage.getItem('bookingDetails') || '{}');

                if (bookingDetails.activityes) {
                    // Safely access the activityes property
                    this.selectedActivityList = bookingDetails.activityes || [];

                } else {
                    this.selectedActivityList = itineraryListItems.map((dayData, dayIndex) => {
                        const activities = dayData.homePackageDetailsItinerarySubDataData
                            .filter(item => item.itineraryViewType === "Activity")
                            .map(activity => ({
                                iamge: activity.iamge,
                                activityID: activity.activityID,
                                activityTitle: activity.activityTitle,
                                description: activity.description,
                                activityTime: activity.activityTime || null, // Add other fields if they exist
                                location: activity.location || null,
                                duration: activity.duration || null,
                                startDate: activity.startDate || null,
                                discountPrice: activity.discountPrice || "0",
                                perPersonalPrice: activity.perPersonalPrice || null,
                                // activityTraveller: this.totalTravellers,
                            }));

                        const Hotel = dayData.homePackageDetailsItinerarySubDataData
                            .filter((item: any) => {
                                // console.log(item)
                                if (item.itineraryViewType === 'Hotel') {
                                    return item;
                                }
                            });

                        const Vehicle = dayData.homePackageDetailsItinerarySubDataData
                            .filter((item: any) => {
                                // console.log(item)
                                if (item.itineraryViewType === 'Car') {
                                    return item;
                                }
                            });
                        return {
                            day: parseInt(dayData.days, 10),
                            selectedHotel: Hotel,
                            selectedVehicle: Vehicle,
                            activities: activities,
                        };
                    });
                    let defaultPackageHVAData = itineraryListItems.map((dayData, dayIndex) => {
                        const activities = dayData.homePackageDetailsItinerarySubDataData
                            .filter(item => item.itineraryViewType === "Activity")
                            .map(activity => ({
                                iamge: activity.iamge,
                                activityID: activity.activityID,
                                activityTitle: activity.activityTitle,
                                description: activity.description,
                                activityTime: activity.activityTime || null, // Add other fields if they exist
                                location: activity.location || null,
                                duration: activity.duration || null,
                                startDate: activity.startDate || null,
                                discountPrice: activity.discountPrice || "0",
                                perPersonalPrice: activity.perPersonalPrice || null,
                            }));

                        const Hotel = dayData.homePackageDetailsItinerarySubDataData
                            .filter((item: any) => {
                                // console.log(item)
                                if (item.itineraryViewType === 'Hotel') {
                                    return item;
                                }
                            });

                        const Vehicle = dayData.homePackageDetailsItinerarySubDataData
                            .filter((item: any) => {
                                // console.log(item)
                                if (item.itineraryViewType === 'Car') {
                                    const carsRequired = Math.ceil(this.totalTravellers / parseInt(item.carSeaterAc));
                                    const totalPrice = carsRequired * item.vehicleFinalPrice;
                                    item.cars = carsRequired;
                                    item.basePrise = item.vehicleFinalPrice;
                                    item.FinalPrice = totalPrice;
                                    return item;
                                }
                            });
                        return {
                            day: parseInt(dayData.days, 10),
                            selectedHotel: Hotel,
                            selectedVehicle: Vehicle,
                            activities: activities,
                        };
                    });
                    this.defaultPackageHVAData = defaultPackageHVAData;
                    this.initializeHotelImageSlider();
                }

            }
            else {
            }
        }, (error) => {
        });
    }

    getPolicyDataPlaceId() {
        this.userLayoutService.getPolicyDataByPlaceId(this.packageId).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    this.policyDataList = response.data;
                    this.cancellationPolicy = this.policyDataList.find(
                        (policy: any) => policy.policyName === "Cancellation Policy"
                    );
                    this.termsAndConditionPolicy = this.policyDataList.find(
                        (policy: any) => policy.policyName === "Terms & Conditions"
                    );

                    /*this.calculateCancellationDates();*/ // Process all policies
                } else {
                    console.error('Failed to fetch policy data');
                }
            },
            (error) => {
                console.error('Error fetching policy data:', error);
            }
        );
    }



    getvehicleDatavehicleId(VehicleId: any) {
        this.userLayoutService.getVehicleDataByVehicleId(VehicleId).subscribe((Response: any) => {

            if (Response.code == 1) {
                this.vehicleDataList = Response.data;
                $("#vahicleDetails").modal('show');

            }
            else {
                Response.error
                // this.router.navigate(['home']);
            }
        }, (error) => {
            // this.router.navigate(['home']);
        });
    }

    getHotelDataHotelId(HotelId: any, placeId: any) {
        this.hotelDataList = []
        this.userLayoutService.getHotelDataByHotelId(HotelId).subscribe((Response: any) => {

            if (Response.code == 1) {

                this.hotelDataList = Response.data;
                setTimeout(() => {
                    if (this.hotelDataList.imagePaths?.length > 0) {
                        $('.hotel-slick-slider').slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: true,
                            autoplay: false,
                            autoplaySpeed: 3000,
                            infinite: true
                        });
                    } else {
                        if ($('.hotel-slick-slider').hasClass('slick-initialized')) {
                            $('.hotel-slick-slider').slick('unslick');
                            // console.log("unslicked")
                        }
                    }
                }, 0.5);
                this.openhoteldetailspopup()
            }
            else {
                Response.error
                // this.router.navigate(['home']);
            }
        }, (error) => {
            // this.router.navigate(['home']);
        });
    }
    openhoteldetailspopup() {
        $('.overlay').fadeIn();
        $('.hotel_details_popup').css({
            'right': '0',
            'transition': 'all 0.5s ease',
        });
    }
    getActivityDataPlaceId(placeId: any) {
        let dataObj = {
            placeId: placeId
        };
        this.userLayoutService.getActivityDataByPlaceId(dataObj).subscribe((Response: any) => {
            if (Response.code == 1) {
                this.searchTerm = '';
                this.activityDataList = Response.data;
                // console.log(this.selectedActivityList);
                const selectedDayActivities = this.selectedActivityList.find(
                    (entry: any) => entry.day == this.tempActivityDay)?.activities || [];

                this.activityDataList.forEach((activity: any) => {
                    const matchedActivity = selectedDayActivities.find(
                        (selectedActivity: any) => selectedActivity.activityID === activity.activityID
                    );
                    // console.log(matchedActivity);
                    activity.selected = !matchedActivity;
                    activity.confirmation = matchedActivity;
                    activity.activityTraveller = matchedActivity?.activityTraveller || (this.totalTravellers + this.totalBabyChild);
                });
                this.filterActivities();
            } else {
                // this.router.navigate(['home']);
            }
        }, (error) => {
            // this.router.navigate(['home']);
        });
    }

    getCityListById() {
        this.userLayoutService.getCityDataByPlaceId(this.packageId).subscribe((Response: any) => {

            if (Response.code == 1) {
                this.cities = Response.data;
            }
            else {
                Response.error
                // this.router.navigate(['home']);
            }
        }, (error) => {
            // this.router.navigate(['home']);
        });
    }


    getHotelsListbyPlace(placeId: any, day: any, hotelId: any, roomId: any) {
        // console.log("on get", day, this.selectedActivityList, this.defaultPackageHVAData);
        this.tempActivityDay = parseInt(day);
        let payload = {
            placeId: placeId,
            hotelId: hotelId,
            roomId: roomId,
        }
        this.userLayoutService.getHotelWithRoomDataByHotelId(payload).subscribe(
            (Response: any) => {
                if (Response.code == 1) {
                    // Initialize hotelDataListByPlace with selected = false
                    this.hotelDataListByPlace = Response.data.map((hotel: any) => ({
                        ...hotel,
                        selected: false,
                    }));

                    this.itineraryDataList.forEach((itineraryItem: any) => {
                        // console.log(itineraryItem, day)
                        if (itineraryItem.days == day) {
                            // console.log(itineraryItem);
                            itineraryItem.homePackageDetailsItinerarySubDataData
                                .filter((item: any) => {
                                    // // console.log(item)
                                    if (item.itineraryViewType === 'Hotel') {
                                        // console.log(item);
                                        this.selectedHotel = item.hotelId;
                                        this.hotelDataListByPlace.forEach((hotel: any) => {
                                            if (hotel.hotelID === this.selectedHotel) {
                                                hotel.selected = true;
                                            }
                                        });
                                        // this.selectedActivityList.forEach((activity: any) => {
                                        //   if (activity.day == day) {
                                        //     activity.hotelId = this.selectedHotel;
                                        //   } else {
                                        //     this.selectedActivityList.push({
                                        //       day: day,
                                        //       hotelId: this.selectedHotel
                                        //     });
                                        //   }
                                        // });
                                    }
                                })

                        }
                    })
                    // console.log(this.hotelDataListByPlace)
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error.error.message);
            }
        );
    }

    getVehiclesListbyPlace(placeId: any, day: any) {
        // console.log("on get", day, this.selectedActivityList);
        this.tempActivityDay = parseInt(day);
        this.userLayoutService.getVehicleList({ placeId }).subscribe(
            (Response: any) => {
                if (Response.code == 1) {
                    // Initialize hotelDataListByPlace with selected = false
                    this.vehicleDataListByPlace = Response.data.map((vehicle: any) => ({
                        ...vehicle,
                        selected: false,
                    }));

                    this.itineraryDataList.forEach((itineraryItem: any) => {
                        // console.log(itineraryItem, day)
                        if (itineraryItem.days == day) {
                            // console.log(itineraryItem);
                            itineraryItem.homePackageDetailsItinerarySubDataData
                                .filter((item: any) => {
                                    // console.log(item)
                                    if (item.itineraryViewType === 'Car') {
                                        // console.log(item);
                                        this.selectedvehicle = item.vehicleId;
                                        this.vehicleDataListByPlace.forEach((vehicle: any) => {
                                            if (vehicle.id === this.selectedvehicle) {
                                                vehicle.selected = true;
                                            }
                                        });
                                    }
                                })

                        }
                    })
                    // console.log(this.vehicleDataListByPlace)
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error.error.message);
            }
        );
    }

    getRoomsListbyHotel(hotel) {
        this.tempSelectedHotel = hotel;
        let payload = {
            hotelId: hotel.hotelID,
        }
        this.userLayoutService.getRoomDataByHotelId(payload).subscribe(
            (Response: any) => {
                if (Response.code == 1) {
                    // Initialize hotelDataListByPlace with selected = false
                    this.roomsDataListByHotel = Response.data.map((room: any) => ({
                        ...room,
                        selected: room.roomId === hotel.roomId,
                    }));
                    // console.log(hotel.roomId);
                    $("#changehotelSidebar").offcanvas('hide');
                    $("#changeRoomSidebar").offcanvas('show');

                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error.error.message);
            }
        );
    }

    backToHotel() {
        $("#changeRoomSidebar").offcanvas('hide');
        $("#changehotelSidebar").offcanvas('show');
    }

    toggleDropdown(index: number): void {
        // this.dropdownStates[index] = !this.dropdownStates[index];
        this.dropdownStates = this.dropdownStates.map((_, i) => i === index ? !this.dropdownStates[i] : false);
        this.initializeHotelImageSlider();
    }

    getActivityByDay(day: any, placeId: any) {
        this.tempActivityDay = day;
        this.getActivityDataPlaceId(placeId);
        // console.log("activities", this.selectedActivityList)
    }

    onImageError(event: any) {
        event.target.src = 'assets/images/safenet_logo_new.png';
    }

    getPackagesDetailsByCategoryId(id: any, name: any) {
        this.router.navigate(['packages'], {
            queryParams: { categoryId: id, title: name }
        });
    }

    createTempActivity(ActivityId: any, index: any) {
        this.updatedPrice = this.updatedPrice + ((parseInt(ActivityId.discountPrice) * parseInt(ActivityId.activityTraveller)) / this.totalTravellers)
        // this.calculateTax(this.updatedPrice);
        this.activityDataList[index].selected = true;
        const activity = this.activityDataList[index];
        activity.selected = true;
        // this.selectedActivityList.push(this.activityDataList[index]);

        const existingDayEntry = this.selectedActivityList.find(
            (dayEntry: any) => dayEntry.day == this.tempActivityDay
        );
        // console.log("existing", existingDayEntry);

        if (existingDayEntry) {
            existingDayEntry.activities.push(activity);
            // console.log("existing", this.selectedActivityList);
        } else {
            this.selectedActivityList.push({
                day: this.tempActivityDay,
                // activityTraveller: 1,
                activities: [activity]
            });
            // console.log("new", this.selectedActivityList);
        }
        $('.overlay').fadeOut();
        $('.add_activity_area').css({
            'right': '-100%',
            'transition': 'all 0.5s ease',
        });
    }

    removeTempActivity(ActivityId: any, index: any, activityData) {
        this.updatedPrice = this.updatedPrice - ((parseInt(activityData.discountPrice) * parseInt(activityData.activityTraveller)) / this.totalTravellers);
        this.activityDataList[index].selected = false;

        const activity = this.activityDataList[index];

        const existingDayEntry = this.selectedActivityList.find(
            (dayEntry: any) => dayEntry.day == this.tempActivityDay
        );


        if (existingDayEntry) {
            existingDayEntry.activities = existingDayEntry.activities.filter(
                (selectedActivity: any) => selectedActivity.activityID !== ActivityId
            );

            if (existingDayEntry.activities.length === 0) {
                this.selectedActivityList = this.selectedActivityList.filter(
                    (dayEntry: any) => dayEntry.day !== this.tempActivityDay
                );
            }
        }
        $('.overlay').fadeOut();
        $('.add_activity_area').css({
            'right': '-100%',
            'transition': 'all 0.5s ease',
        });
    }

    formatDate(date: any): string {
        return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    }

    formatHotelDate(dateString: string): string {
        // Use DatePipe to format as DD-MM-YYYY
        return this.datePipe.transform(dateString, 'dd-MM-yyyy') || '';
    }

    formatDateToShort(dateString: string): string {
        // Use DatePipe to format as DD MMM
        return this.datePipe.transform(dateString, 'dd MMM') || '';
    }

    formatTimeToAMPM(timeString: string | undefined): string {
        if (!timeString) {
            return ''; // Handle undefined or empty strings gracefully
        }

        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format
        return `${formattedHours}:${String(minutes).padStart(2, '0')} ${ampm}`; // Format as HH:MM AM/PM
    }

    // closeContactDetails() {
    //     $("#contactDetailsModal").modal('hide');
    //     this.contactDetailsForm.reset();
    //     this.defaultContactDetailsForm();
    // }

    closeUpperModel(modalToOpen: string, modalToClose: string) {
        $(`#${modalToClose}`).modal('hide');

        setTimeout(function () {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $(`#${modalToOpen}`).modal('show');
        }, 300);

    }

    navigateToHome() {
        $('#enquiryConfirmation').modal('hide');

        setTimeout(() => {
            $('.modal-backdrop').remove();

            $('body').removeClass('modal-open');

            this.router.navigate(['/home']);
        }, 300);
    }


    onBooking() {
        this.bookingFormSubmitted = true;
        let startDate, endDate;
        if (this.selectedStartDate && this.selectedEndDate) {
            startDate = this.formatDate(this.selectedStartDate);
            endDate = this.formatDate(this.selectedEndDate);
        }

        const arrivalCityValue = this.bookingForm.get('arrivalCity')?.value;
        if (this.bookingForm.invalid || this.selectedStartDate == null || this.selectedEndDate == null || !arrivalCityValue || startDate == null || endDate == null) {
            // if (this.selectedStartDate == null && this.selectedEndDate == null) {
            //   this.commonService.notifier.notify('error', "please select date");
            // }

            // if (totalPerson < 1) {
            //   this.commonService.notifier.notify('error', "please select atleast 1 traveler");
            // }
        } else {
            let bookingID, bookingNo;
            let preBookingObj;
            // console.log("dataaaa", this.selectedActivityList);
            const activitiesData = this.selectedActivityList.map((dayEntry: any) => ({
                day: dayEntry.day,
                hotelId: dayEntry.selectedHotel[0]?.hotelId,
                roomId: dayEntry.selectedHotel[0]?.roomId,
                vehicleId: dayEntry.selectedVehicle[0]?.vehicleId,
                activities: dayEntry.activities.map((activity: any) => ({
                    activityID: activity.activityID,
                    activityTraveller: activity.activityTraveller || this.totalTravellers,
                }))
            }));
            const travelers = this.ReviewbookingForm.value.travelerInfo.map((traveler: any, index: number) => ({
                order: index + 1,
                name: traveler.name,
                age: traveler.age,
                gender: traveler.gender
            }));
            preBookingObj = {
                bookingId: null,
                userId: this.userId ? this.userId : null,
                packageId: this.packageId,
                startDate: startDate,
                endDate: endDate,
                arrivalCity: this.bookingForm.get('arrivalCity')?.value,
                adults: this.totalAdults,
                children: this.totalChildren,
                toddler: this.totalBabyChild,
                seniorCitizen: 0,
                currency: this.commonService.currentCurrency,
                guestName: this.contactDetailsForm.get('name')?.value || null,
                guestEmail: this.contactDetailsForm.get('email')?.value || null,
                guestCountryCode: this.contactDetailsForm.get('countryCode')?.value || null,
                guestMobilenumber: this.contactDetailsForm.get('contactNumber')?.value || null,
                travelerInfo: travelers,
                activityes: activitiesData || null,
                roomDeatils: this.rooms,
                perPersonPrice: this.updatedPrice,
                subTotalAmount: this.subTotalPrice,
                taxAmount: this.packagePriceTax,
                totalAmount: (this.subTotalPrice + this.packagePriceTax).toFixed(2),
                perPersonAvgPrice: ((this.subTotalPrice + this.packagePriceTax) / this.totalTravellers).toFixed(2),
            }

            this.userLayoutService.addBookingPackageDataTemp(preBookingObj).subscribe(
                (response: any) => {
                    if (response.code === 1) {
                        bookingID = response.data.bookingId;
                        bookingNo = response.data.bookingNo;

                    } else {
                        this.commonService.notifier.notify('error', "An Error Occured While Booking");
                    }
                },
                (error) => {
                }
            );
        }
    }

    onChangeHotelSelect(hotel: any) {
        // console.log(this.defaultPackageHVAData[this.tempActivityDay - 1])
        // console.log("prev", this.selectedActivityList, hotel)
        // console.log(this.updatedPrice, this.roundedPricePerPerson(hotel.roomPrice, this.defaultPackageHVAData[this.tempActivityDay - 1]?.selectedHotel[0]?.roomPrice));
        this.updatedPrice = this.updatedPrice + (this.roundedPricePerPerson(hotel.roomPrice, this.defaultPackageHVAData[this.tempActivityDay - 1]?.selectedHotel[0]?.roomPrice) / this.totalTravellers);
        // this.calculateTax(this.updatedPrice);
        this.itineraryDataList.forEach((itineraryItem: any) => {
            // console.log(itineraryItem, day)
            if (itineraryItem.days == this.tempActivityDay) {
                // console.log(itineraryItem);
                itineraryItem.homePackageDetailsItinerarySubDataData
                    .filter((item: any) => {
                        // console.log(item)
                        if (item.itineraryViewType === 'Hotel') {
                            // console.log(item);
                            item.hotelId = hotel.hotelID
                            // item.hotelCheckIn = hotel.
                            item.hotelImage = hotel.hotelImages
                            item.hotelRating = hotel.hotelRating
                            item.hotelName = hotel.hotelName
                            item.hotelLocation = hotel.address
                            item.roomId = hotel.roomId
                            item.roomPrice = hotel.roomPrice
                            item.roomType = hotel.roomType
                            item.standardAdults = hotel.standardAdults
                            item.standardChildren = hotel.standardChildren
                            item.totalRoom = hotel.totalRoom
                            item.maxChildren = hotel.maxChildren
                            item.maxAdults = hotel.maxAdults
                            // item.hotelCheckInDate = hotel.
                            // item.hotelCheckOutDate = hotel.
                            this.selectedHotel = [];
                            this.tempSelectedHotel = []
                            this.selectedHotel.push(item);
                            this.hotelDataListByPlace.forEach((hotel: any) => {
                                if (hotel.hotelID === this.selectedHotel[0].hotelId) {
                                    hotel.selected = true;
                                } else {
                                    hotel.selected = false;
                                }
                            });
                        }
                    })
            }
        })
        // this.selectedHotel = hotel;
        // this.hotelDataListByPlace.forEach((hotel: any) => {
        //   if (hotel.hotelID === this.selectedHotel.hotelID) {
        //     hotel.selected = true;
        //   } else {
        //     hotel.selected = false;
        //   }
        // });
        const existingActivity = this.selectedActivityList.find(
            (activity: any) => activity.day === this.tempActivityDay
        );

        if (existingActivity) {
            // If found, update the selectedHotel for the existing activity
            existingActivity.selectedHotel = this.selectedHotel;
        } else {
            // If not found, add a new activity with tempActivityDay
            this.selectedActivityList.push({
                day: this.tempActivityDay,
                selectedHotel: this.selectedHotel,
            });
        }
        // console.log(this.selectedActivityList);
    }

    onChangeVehicleSelect(vehicleID: any) {
        // console.log("prev", this.selectedActivityList, vehicleID)
        let updatablePrice = (this.roundedPricePerPersonVehicle(vehicleID.pricePerPerson, vehicleID.carSeaterAc) / this.totalTravellers)
        this.updatedPrice = this.updatedPrice + updatablePrice;
        // this.calculateTax(this.updatedPrice);
        this.itineraryDataList.forEach((itineraryItem: any) => {
            // console.log(itineraryItem, day)
            if (itineraryItem.days == this.tempActivityDay) {
                // console.log(itineraryItem);
                itineraryItem.homePackageDetailsItinerarySubDataData
                    .filter((item: any) => {
                        // console.log(item)
                        if (item.itineraryViewType === 'Car') {
                            // console.log(item);
                            item.vehicleId = vehicleID.id
                            // item.hotelCheckIn = hotelid.
                            item.carName = vehicleID.vehicleName
                            item.vehicleImage = vehicleID.image
                            item.carSeaterAc = vehicleID.carSeaterAc
                            // item.carPickUp = vehicleID.hotelName
                            item.vehicleFinalPrice = vehicleID.pricePerPerson
                            item.vehicleType = vehicleID.type
                            // item.hotelCheckInDate = hotelid.
                            // item.hotelCheckOutDate = hotelid.
                            this.selectedvehicle = []
                            this.selectedvehicle.push(item);
                            this.vehicleDataListByPlace.forEach((vehicle: any) => {
                                if (vehicle.id === this.selectedvehicle[0].vehicleId) {
                                    vehicle.selected = true;
                                } else {
                                    vehicle.selected = false;
                                }
                            });
                        }
                    })

            }
        })
        // this.selectedHotel = hotelid;
        // this.hotelDataListByPlace.forEach((hotel: any) => {
        //   if (hotel.hotelID === this.selectedHotel.hotelID) {
        //     hotel.selected = true;
        //   } else {
        //     hotel.selected = false;
        //   }
        // });
        const existingActivity = this.selectedActivityList.find(
            (activity: any) => activity.day === this.tempActivityDay
        );

        if (existingActivity) {
            // If found, update the selectedHotel for the existing activity
            existingActivity.selectedVehicle = this.selectedvehicle;
        } else {
            // If not found, add a new activity with tempActivityDay
            this.selectedActivityList.push({
                day: this.tempActivityDay,
                selectedVehicle: this.selectedvehicle,
            });
        }
        $("#changeVahicalSidebar").offcanvas('hide');

        // console.log(this.selectedActivityList);
    }

    onHotelRoomChange(roomData) {
        // this.updatedPrice = this.updatedPrice + (roomData.roomPrice - this.defaultPackageHVAData[this.tempActivityDay-1]?.selectedHotel[0]?.roomPrice);
        this.roomsDataListByHotel.forEach((room: any) => {
            if (room.roomId === roomData.roomId) {
                room.selected = true;
            } else {
                room.selected = false;
            }
        });
        // console.log(this.tempSelectedHotel)
        // this.tempSelectedHotel.forEach((item: any) => {
        this.tempSelectedHotel.roomId = roomData.roomId
        this.tempSelectedHotel.roomPrice = roomData.roomPrice
        this.tempSelectedHotel.roomType = roomData.roomType
        this.tempSelectedHotel.standardAdults = roomData.standardAdults
        this.tempSelectedHotel.standardChildren = roomData.standardChildren
        this.tempSelectedHotel.totalRoom = roomData.totalRoom
        this.tempSelectedHotel.maxChildren = roomData.maxChildren
        this.tempSelectedHotel.maxAdults = roomData.maxAdults
        // });
        this.onChangeHotelSelect(this.tempSelectedHotel);
        this.backToHotel();
    }

    capitalizeFirstLetter(text: string): string {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    formatDescription(description: string): SafeHtml {
        // Clean the description to remove unwanted tags and ensure proper formatting
        const cleanedDescription = description
            .replace(/<div>/g, '') // Remove opening div tags
            .replace(/<\/div>/g, '') // Remove closing div tags
            .replace(/&#160;/g, ' ') // Replace HTML non-breaking spaces with normal spaces
            .replace(/(&#8217;|&#8216;)/g, "'"); // Replace HTML quotes with single quotes

        // Return sanitized HTML with proper list formatting
        const formattedDescription = cleanedDescription
            .split('-') // Split by dash (assuming each policy starts with a dash)
            .filter((line) => line.trim() !== '') // Remove empty lines
            .map((line) => `<li style="font-size: 18px; font-weight: 400;">${line.trim()}</li>`) // Add inline styles for font-size and font-weight
            .join('');

        return this.sanitizer.bypassSecurityTrustHtml(`<ul>${formattedDescription}</ul>`);
    }


    onStartDateChange(date: Date): void {
        if (date) {
            this.selectedStartDate = date;
            this.selectedEndDate = new Date(date);
            this.selectedEndDate.setDate(date.getDate() + this.overviewDataList.totalDay - 1);
        } else {
            this.selectedEndDate = null as any;
        }
    }

    setUserForPrimary() {
        let userData = JSON.parse(localStorage.getItem("LoginUserData"));
        if (this.useForPrimary && this.travelerInfo.length > 0) {
            if (userData) {
                // console.log(userData);
                const contactName = userData.firstName + ' ' + userData.lastName;
                this.travelerInfo.controls[0].patchValue({
                    name: contactName,
                });
            } else {
                const contactName = this.contactDetailsForm.get('name')?.value || '';
                this.travelerInfo.controls[0].patchValue({
                    name: contactName,
                });
            }
        } else {
            this.travelerInfo.controls[0].patchValue({
                name: '',
            });
        }
    }

    onEnquiryOpen(isEnquiry: boolean) {
        this.isInquiry = isEnquiry;
        this.calculateDiscountedPrice();
        if (this.bookingForm.get('arrivalCity')?.value && this.selectedStartDate && this.selectedEndDate && this.acknowledged) {
            this.defaultReviewBookingForm();
            this.setUserForPrimary();
            $("#enquireNow").modal('show');
        }
        else {
            if (this.bookingForm.get('arrivalCity')?.value != "" && this.selectedStartDate && this.selectedEndDate && !this.acknowledged) {
                $('.itinerarybtn').removeClass('active');
                $('.summarybtn').addClass('active');
                $('.itinerary_list_area').fadeOut();
                $('.summery_items_area').fadeIn();
                setTimeout(() => {
                    const targetElement = document.getElementById('acknowledge-area');
                    targetElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 500);
                this.commonService.notifier.notify('error', "Please review & acknowledge privacy statement & government travel advice.");
            } else {
                if (!this.bookingForm.get('arrivalCity')?.value && !this.selectedStartDate) {
                    setTimeout(() => {
                        const targetElement = document.getElementById('arrival_city');
                        targetElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 0);
                    // this.commonService.notifier.notify('error', "Please select arrival city & date.");
                }
                else if (!this.bookingForm.get('arrivalCity')?.value && this.selectedStartDate) {
                    setTimeout(() => {
                        const targetElement = document.getElementById('arrival_city');
                        targetElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 0);
                    // this.commonService.notifier.notify('error', "Please select arrival city.");
                }
                else if (this.bookingForm.get('arrivalCity')?.value && !this.selectedStartDate) {
                    setTimeout(() => {
                        const targetElement = document.getElementById('start_date');
                        targetElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 0);
                    // this.commonService.notifier.notify('error', "Please select date.");
                }
            }
        }

    }

    textInput(event: any, formName: string, controlName: string): void {
        const input = event.target;
        input.value = input.value.replace(/[^a-zA-Z ]/g, '');

        if (this[formName] && this[formName].patchValue) {
            this[formName].patchValue({
                [controlName]: input.value || null,
            });
        }
        this.setUserForPrimary();
    }

    defaultReviewBookingForm() {
        this.bookingFormSubmitted = false;
        this.travelerInfoSuccess = false;

        this.ReviewbookingForm = this.fb.group({
            travelerInfo: this.fb.array([])
        });

        this.addTravelers(this.totalAdults, 'Adult');
        this.addTravelers(this.totalChildren, 'Child');
        // this.addTravelers(this.totalBabyChild, 'Infant');
        // this.addTravelers(this.seniorCitizen);
        // console.log(this.travelerInfo.controls);

    }

    get travelerInfo(): FormArray {
        return this.ReviewbookingForm?.get('travelerInfo') as FormArray;
    }

    // Method to create and add a FormGroup to the FormArray for each traveler
    addTravelers(count: number, person: any): void {
        for (let i = 0; i < count; i++) {
            const travelerFormGroup = this.fb.group({
                bookingId: [this.bookingId],
                name: ['', Validators.required],
                age: ['', [Validators.required, this.ageValidator(person)]],
                gender: ['', Validators.required],
                person: person,
                count: i + 1
            });
            this.travelerInfo.push(travelerFormGroup);
        }
    }

    ageValidator(person: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const age = control.value;
            if (person === 'Adult' && (age < 12 || age > 120)) {
                return { ageInvalid: true };
            }
            if (person === 'Child' && (age < 5 || age > 11)) {
                return { ageInvalid: true };
            }
            return null;
        };
    }

    calculateDiscountedPrice() {
        if (this.discountPercentage <= 0) {
            this.discount = 0;
            this.discountedSubTotal = this.subTotalPrice;
            this.discountedTotalPrice = parseFloat((this.discountedSubTotal + this.packagePriceTax).toFixed(2));
            return;
        }

        if (this.isPercentage) {
            const discountAmount = (this.subTotalPrice * this.discountPercentage) / 100;
            this.discount = parseFloat(discountAmount.toFixed(2));
        } else {
            const discountAmount = this.discountPercentage;
            this.discount = parseFloat(discountAmount.toFixed(2));
        }

        this.discountedSubTotal = parseFloat((this.subTotalPrice - this.discount).toFixed(2));
        this.discountedTotalPrice = parseFloat((this.discountedSubTotal + this.packagePriceTax).toFixed(2));
    }


    onEnquiry() {
        this.bookingFormSubmitted = true;
        let startDate, endDate;
        if (this.selectedStartDate && this.selectedEndDate) {
            startDate = this.formatDate(this.selectedStartDate);
            endDate = this.formatDate(this.selectedEndDate);
        }
        const travelerInfoInvalid = this.travelerInfo?.controls?.some((traveler: AbstractControl) => {
            const ageErrors = traveler.get('age')?.errors;
            return ageErrors?.ageInvalid && !ageErrors?.required;
        }) ?? false;
        const arrivalCityValue = this.bookingForm.get('arrivalCity')?.value;

        if (this.bookingForm.invalid || this.selectedStartDate == null || this.selectedEndDate == null || !arrivalCityValue || startDate == null || endDate == null || this.ReviewbookingForm.invalid || this.guestUser ? this.contactDetailsForm.invalid : false) {
            // if (this.selectedStartDate == null && this.selectedEndDate == null) {
            //   this.commonService.notifier.notify('error', "please select date");
            // }

            // if (totalPerson < 1) {
            //   this.commonService.notifier.notify('error', "please select atleast 1 traveler");
            // }
            return;
        } else {
            let bookingID, bookingNo;
            let preBookingObj;
            const activitiesData = this.selectedActivityList.map((dayEntry: any) => ({
                day: dayEntry.day,
                hotelId: dayEntry.selectedHotel[0]?.hotelId,
                roomId: dayEntry.selectedHotel[0]?.roomId,
                vehicleId: dayEntry.selectedVehicle[0]?.vehicleId,
                activities: dayEntry.activities.map((activity: any) => ({
                    activityID: activity.activityID,
                    activityTraveller: activity.activityTraveller || this.totalTravellers,
                }))
            }));
            const travelers = this.ReviewbookingForm.value.travelerInfo.map((traveler: any, index: number) => ({
                order: index + 1,
                name: traveler.name,
                age: traveler.age,
                gender: traveler.gender
            }));
            preBookingObj = {
                bookingId: null,
                userId: this.userId ? this.userId : null,
                packageId: this.packageId,
                startDate: startDate,
                endDate: endDate,
                arrivalCity: this.bookingForm.get('arrivalCity')?.value,
                adults: this.totalAdults,
                children: this.totalChildren,
                toddler: this.totalBabyChild,
                seniorCitizen: 0,
                currency: this.commonService.currentCurrency,
                currencyValue: this.commonService.currencyConversionRate,
                currencySymbol: this.commonService.currencySymbol,
                guestName: this.contactDetailsForm.get('name')?.value || null,
                guestEmail: this.contactDetailsForm.get('email')?.value || null,
                guestCountryCode: this.contactDetailsForm.get('countryCode')?.value || null,
                guestMobilenumber: this.contactDetailsForm.get('contactNumber')?.value || null,
                travelerInfo: travelers,
                activityes: activitiesData || null,
                roomDeatils: this.rooms,
                perPersonPrice: this.updatedPrice,
                subTotalAmount: this.subTotalPrice,
                taxAmount: this.packagePriceTax,
                totalAmount: (this.subTotalPrice + this.packagePriceTax).toFixed(2),
                perPersonAvgPrice: ((this.subTotalPrice + this.packagePriceTax) / this.totalTravellers).toFixed(2),
            }

            this.userLayoutService.addBookingPackageDataTemp(preBookingObj).subscribe(
                (response: any) => {
                    if (response.code === 1) {
                        bookingID = response.data.bookingId;
                        bookingNo = response.data.bookingNo;
                        this.bookingId = bookingID;
                        this.bookingNo = bookingNo;
                        // console.log(bookingID, bookingNo);
                        this.calculateDiscountedPrice();
                        this.travelerInfoSuccess = true;
                        // localStorage.removeItem('bookingDetails');
                        let paymentObj = {
                            bookingId: bookingID,
                            promoId: this.promoCodeId || null,
                            promoCode: this.promoCode || null,
                            discountPercentage: this.discountPercentage,
                            discount: this.discount,
                            discountedPrice: this.discountedSubTotal,
                            taxAmount: this.packagePriceTax,
                            totalAmount: this.discountedTotalPrice,
                        };
                        // console.log(paymentObj);

                        this.userLayoutService.standardPackageInquiry(paymentObj).subscribe(
                            (response: any) => {
                                if (response.code === 1) {
                                    this.travelerInfoSuccess = true;
                                    this.commonService.notifier.notify('success', 'Enquiry has been sent successfully.');
                                    $("#enquireNow").modal('hide');
                                    $("#enquiryConfirmation").modal('show');
                                } else {
                                    this.commonService.notifier.notify('error', response.message);
                                }
                            },
                            (error) => {
                                console.error('API Error:', error);
                                this.commonService.notifier.notify('error', error);
                            }
                        );
                    } else {
                        this.commonService.notifier.notify('error', "An Error Occured While Booking");
                    }
                },
                (error) => {
                }
            );
        }
    }

    openPromoApply() {
        this.searchTerm = '';
        let payload: any = {
            PackageId: this.packageId,
            TotalAmount: this.discountedTotalPrice,
            IsDomestic: localStorage.getItem("currencyCode") === 'INR',
            ...(this.userId && { UserId: this.userId })
        };

        this.userLayoutService.getPromoCodes(payload).subscribe(
            (Response: any) => {
                if (Response.code == 1) {
                    this.promoCodesList = Response.data;
                    $('.overlay').fadeIn();
                    $('.add_promo_area').css({
                        'right': '0',
                        'transition': 'all 0.5s ease',
                    });
                    this.filterPromos();
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error.error.message);
            }
        );
    }

    applyPromo(promoCode) {
        this.promoCode = promoCode;
        // this.getReviewBookingDetailsById();
        let promoObj = {
            promoCode: this.promoCode,
            packageId: this.packageId,
            bookingId: this.bookingId,
        };
        this.userLayoutService.applyPromoCode(promoObj).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    // this.discountPercentage = 0;
                    //   this.reviewBookingDetails.promoCode = this.promoCode;
                    this.promoCodeId = response.data.promoId;
                    this.isPercentage = response.data.isPercentage;
                    this.discountPercentage = parseInt(response.data.discountPercentage);
                    this.calculateDiscountedPrice()
                    //   this.promoMessage = "Promo code applied";
                    //   this.promoMessageClass = "success";
                } else {
                    this.discountPercentage = 0;
                    //   this.getReviewBookingDetailsById();
                    //   this.promoMessage = "Promo code invalid or expired !";
                    //   this.promoMessageClass = "error";
                }
                $('.overlay').fadeOut();
                $('.add_promo_area').css({
                    'right': '-100%',
                    'transition': 'all 0.5s ease',
                });
            },
            (error) => {
                this.discountPercentage = 0;
                // this.getReviewBookingDetailsById();
                // this.promoMessage = "Promo code invalid or expired !";
                // this.promoMessageClass = "error";
            }
        );
    }

    cancelPromoCode() {
        this.promoCode = '';
        this.promoCodeId = '';
        this.discountPercentage = 0;
        this.calculateDiscountedPrice();
    }

    filterNonNumeric(event: Event, traveler: FormGroup): void {
        const inputElement = event.target as HTMLInputElement;
        const numericValue = inputElement.value.replace(/\D/g, '');
        traveler.get('age')?.setValue(numericValue);
    }

    filterTextInput(event: Event, traveler: FormGroup): void {
        const inputElement = event.target as HTMLInputElement;
        const numericValue = inputElement.value.replace(/[^a-zA-Z ]/g, '');
        traveler.get('name')?.setValue(numericValue);
    }

    filterActivities(): void {
        const search = this.searchTerm.toLowerCase().trim();
        if (search === '') {
            this.filteredActivityDataList = [...this.activityDataList];
        } else {
            this.filteredActivityDataList = this.activityDataList.filter(activity =>
                activity.activityTitle?.toLowerCase().includes(search) ||
                activity.location?.toLowerCase().includes(search)
            );
        }
    }

    filterPromos(): void {
        const search = this.searchTerm.toLowerCase().trim();
        if (search === '') {
            this.filteredPromoCodesList = [...this.promoCodesList];
        } else {
            this.filteredPromoCodesList = this.promoCodesList.filter(promo =>
                promo.promoCode?.toLowerCase().includes(search)
            );
        }
    }

    onPaymentClick() {
        this.bookingFormSubmitted = true;
        let startDate, endDate;
        if (this.selectedStartDate && this.selectedEndDate) {
            startDate = this.formatDate(this.selectedStartDate);
            endDate = this.formatDate(this.selectedEndDate);
        }
        const travelerInfoInvalid = this.travelerInfo?.controls?.some((traveler: AbstractControl) => {
            const ageErrors = traveler.get('age')?.errors;
            return ageErrors?.ageInvalid && !ageErrors?.required;
        }) ?? false;
        const arrivalCityValue = this.bookingForm.get('arrivalCity')?.value;
        if (this.bookingForm.invalid || this.selectedStartDate == null || this.selectedEndDate == null || !arrivalCityValue || startDate == null || endDate == null || this.ReviewbookingForm.invalid || this.guestUser ? this.contactDetailsForm.invalid : false) {
            // if (this.selectedStartDate == null && this.selectedEndDate == null) {
            //   this.commonService.notifier.notify('error', "please select date");
            // }

            // if (totalPerson < 1) {
            //   this.commonService.notifier.notify('error', "please select atleast 1 traveler");
            // }
            return;
        } else {
            this.ClearCardDetails();
            $('#enquireNow').modal('hide');
            $('#cardDetailsModal').modal('show');
        }
    }

    submitCardDetails() {
        this.bookingFormSubmitted = true;
        let startDate, endDate;
        if (this.selectedStartDate && this.selectedEndDate) {
            startDate = this.formatDate(this.selectedStartDate);
            endDate = this.formatDate(this.selectedEndDate);
        }
        const travelerInfoInvalid = this.travelerInfo?.controls?.some((traveler: AbstractControl) => {
            const ageErrors = traveler.get('age')?.errors;
            return ageErrors?.ageInvalid && !ageErrors?.required;
        }) ?? false;
        const arrivalCityValue = this.bookingForm.get('arrivalCity')?.value;
        if (this.bookingForm.invalid || this.selectedStartDate == null || this.selectedEndDate == null || !arrivalCityValue || startDate == null || endDate == null || travelerInfoInvalid) {
            return;
        } else {
            let bookingID, bookingNo;
            let preBookingObj;
            const activitiesData = this.selectedActivityList.map((dayEntry: any) => ({
                day: dayEntry.day,
                hotelId: dayEntry.selectedHotel[0]?.hotelId,
                roomId: dayEntry.selectedHotel[0]?.roomId,
                vehicleId: dayEntry.selectedVehicle[0]?.vehicleId,
                activities: dayEntry.activities.map((activity: any) => ({
                    activityID: activity.activityID,
                    activityTraveller: activity.activityTraveller || this.totalTravellers,
                }))
            }));
            const travelers = this.ReviewbookingForm.value.travelerInfo.map((traveler: any, index: number) => ({
                order: index + 1,
                name: traveler.name,
                age: traveler.age,
                gender: traveler.gender
            }));
            preBookingObj = {
                bookingId: null,
                userId: this.userId ? this.userId : null,
                packageId: this.packageId,
                startDate: startDate,
                endDate: endDate,
                arrivalCity: this.bookingForm.get('arrivalCity')?.value,
                adults: this.totalAdults,
                children: this.totalChildren,
                toddler: this.totalBabyChild,
                seniorCitizen: 0,
                currency: this.commonService.currentCurrency,
                currencyValue: this.commonService.currencyConversionRate,
                currencySymbol: this.commonService.currencySymbol,
                guestName: this.contactDetailsForm.get('name')?.value || null,
                guestEmail: this.contactDetailsForm.get('email')?.value || null,
                guestCountryCode: this.contactDetailsForm.get('countryCode')?.value || null,
                guestMobilenumber: this.contactDetailsForm.get('contactNumber')?.value || null,
                travelerInfo: travelers,
                activityes: activitiesData || null,
                roomDeatils: this.rooms,
                perPersonPrice: this.updatedPrice,
                subTotalAmount: this.subTotalPrice,
                taxAmount: this.packagePriceTax,
                totalAmount: (this.subTotalPrice + this.packagePriceTax).toFixed(2),
                perPersonAvgPrice: ((this.subTotalPrice + this.packagePriceTax) / this.totalTravellers).toFixed(2),
            }

            this.userLayoutService.addBookingPackageDataTemp(preBookingObj).subscribe(
                (response: any) => {
                    if (response.code === 1) {
                        bookingID = response.data.bookingId;
                        bookingNo = response.data.bookingNo;
                        this.bookingId = bookingID;
                        this.bookingNo = bookingNo;
                        // console.log(bookingID, bookingNo);
                        this.calculateDiscountedPrice();
                        this.travelerInfoSuccess = true;

                        if (this.promoCode && this.promoCodeId) {
                            let paymentObj = {
                                bookingId: this.bookingId,
                                promoId: this.promoCodeId || null,
                                promoCode: this.promoCode || null,
                                discountPercentage: this.discountPercentage,
                                discount: this.discount,
                                discountedPrice: this.discountedSubTotal,
                                taxAmount: this.packagePriceTax,
                                totalAmount: this.discountedTotalPrice
                            };

                            this.userLayoutService.updateBookingDetails(paymentObj).subscribe(
                                (response: any) => {
                                    if (response.code === 1) {
                                        this.paymentIntent();
                                    }
                                },
                                (error) => {
                                    // console.error('API Error:', error);
                                    this.commonService.notifier.notify('error', error);
                                }
                            );
                        } else {
                            this.paymentIntent();
                        }
                    }
                }
            );
        }
    }

    paymentIntent() {
        const paymentObj = {
            bookingId: this.bookingId,
            amount: (this.discountedTotalPrice) * 100,
            currency: "usd",
        };

        // Call the service to create a PaymentIntent
        this.userLayoutService.paymentIntent(paymentObj).subscribe(
            async (response: any) => {
                // Retrieve the client secret from the backend response
                const clientSecret = response.clientSecret;

                if (!clientSecret) {
                    console.error('Client secret is not available.');
                    alert('Failed to initiate payment. Please try again.');
                    return;
                }

                // Confirm the payment using the client secret and card details
                const { error, paymentIntent } = await this.stripe.confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: this.card, // Card details collected via Stripe Elements
                        billing_details: {
                            name: this.bookingId, // Replace with actual customer name if available
                        },
                    },
                });

                if (error) {
                    // Handle payment error
                    console.error('Payment error:', error);
                    $('#cardDetailsModal').modal('hide');
                    $('#retryPayment').modal('show');

                } else if (paymentIntent?.status === 'requires_capture') {
                    // Payment succeeded
                    // console.log('Payment successful:', paymentIntent);
                    this.savepaymentDetails(paymentIntent);
                    $('#cardDetailsModal').modal('hide');

                } else {
                    // console.log('Payment unexpected:', paymentIntent);
                    $('#cardDetailsModal').modal('hide');
                    $('#retryPayment').modal('show');
                }
            },
            (error) => {
                // Handle errors in creating PaymentIntent
                // console.error('Error creating payment intent:', error);
                alert('Failed to create payment intent. Please try again.');
            }
        );
    }

    savepaymentDetails(paymentIntent: any) {
        const paymentObj = {
            bookingId: this.bookingId,
            type: "card",
            transactionId: paymentIntent.id,
            currency: "usd",
            amount: (this.discountedTotalPrice) * 100
        };
        this.userLayoutService.paymentProcess(paymentObj).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    // this.commonService.notifier.notify('success', response.message);
                    this.travelerInfoSuccess = true;
                    localStorage.removeItem('bookingDetails');
                    $('#proceedToPayment').modal('show');
                } else {
                    this.commonService.notifier.notify('error', response.message);
                }
            },
            (error) => {
                console.error('API Error:', error);
                this.commonService.notifier.notify('error', error);
            }
        );
    }

    ClearCardDetails() {
        // Reset the card details when modal is opened
        if (this.card) {
            this.card.clear(); // Clear the Stripe card input
        }

        // Optionally, reset any error messages
        const cardErrors = document.getElementById('card-errors');
        if (cardErrors) {
            cardErrors.textContent = ''; // Clear error message
        }
    }
    getISTDate(): Date {
        const nowUTC = new Date();
        const offsetInMinutes = 5.5 * 60; // IST is UTC+5:30
        const istTime = new Date(nowUTC.getTime() + offsetInMinutes * 60 * 1000);
        return istTime;
    }
    searchByName1(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
    }

    //#region Customize Package

    toggleOther(event: Event): void {
        const checkbox = event.target as HTMLInputElement;
        this.showOtherTextbox = checkbox.checked;
        if (!checkbox.checked) {
            this.otherService = ''; // Clear the textbox when unchecked
        }
    }
    toggleFlightForm(event: Event): void {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.flightFormVisible = isChecked;
        this.tripType_flight = 'oneWay';
    }
    defaultAddCustomInqForm(): void {
        if (this.customInqForm == undefined) {
            this.customInqForm = this.fb.group({
                email: ['', [Validators.required, this.customEmailValidator()]],
                phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{8,12}$/)]],
                countryCode: ['+1', [Validators.required]],
                startDate: ['', Validators.required],
                endDate: ['', Validators.required],
                adults: [1, Validators.required],
                children: [0, Validators.required],
                child: [0, Validators.required],
                placeName: ['', Validators.required],
                startCity: [null, Validators.required],
                endCity: [null, Validators.required],
                isSameAsWhatsApp: [false],
                hotel: [true],
                car: [true],
                activities: [true],
                contactPerson: ['', Validators.required],
                comments: [''],
                otherService: [''],
                childAges: this.fb.array([]),
                flightDetails: this.fb.array([]),
            });
        }

        this.flightFormVisible = false;
        setTimeout(() => {
            const flightCheckbox = document.getElementById('flightCheckbox') as HTMLInputElement;
            if (flightCheckbox) {
                flightCheckbox.checked = false;
            }
        });
        this.tripType_flight = 'oneWay';
        this.customInqSubmitted = false;
        this.noOfPersonError = '';
        const today = this.getISTDate()
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() returns 0-11
        const day = String(today.getDate()).padStart(2, '0');
        this.minDate = `${year}-${month}-${day}`;
        this.minStartDate = today;
        this.minEndDate = this.minStartDate;
        this.updatecustomInqForm()
    }
    addCustomPlace = (term) => ({ id: term, names: term });
    AddCustomInquiry() {

        this.customInqSubmitted = true;

        // Check if all child ages are valid
        const childAgesArray = this.customInqForm.get('childAges') as FormArray;

        if (this.customInqForm.invalid || this.personError || childAgesArray.invalid) {
            // Mark all child age controls as touched to trigger validation messages
            childAgesArray.controls.forEach((control) => control.markAsTouched());
            return;
        }

        const selectedPlaces = this.customInqForm.value.placeName;
        const customPackagePlaces = selectedPlaces.map((place: any) => ({ placeId: place }));
        const childAges = childAgesArray.value.map((age: any) => ({ age: age }));

        const payload = {
            email: this.customInqForm.value.email,
            phoneNumber: this.customInqForm.value.phoneNumber,
            startDate: this.convertToISOFormat(this.customInqForm.value.startDate),
            endDate: this.convertToISOFormat(this.customInqForm.value.endDate),
            adults: this.customInqForm.value.adults,
            children: this.customInqForm.value.children,
            toddler: this.customInqForm.value.child,
            startCity: this.customInqForm.value.startCity,
            endCity: this.customInqForm.value.endCity,
            customPackageInquiryDetailsPlaceId: customPackagePlaces,
            isSameAsWhatsApp: this.customInqForm.value.isSameAsWhatsApp,
            hotel: this.customInqForm.value.hotel,
            car: this.customInqForm.value.car,
            activities: this.customInqForm.value.activities,
            contactPerson: this.customInqForm.value.contactPerson,
            comments: this.customInqForm.value.comments,
            countryCode: this.customInqForm.value.countryCode,
            otherService: this.customInqForm.value.otherService,
            childrenAgeDetails: this.customInqForm.value.childAges,

            //for flight detail
            flightDetails: this.flightFormVisible ? this.citySegments_flight.map((segment, index) => {
                // Use the first segment's values for all segments
                const firstSegment = this.citySegments_flight[0];

                return {
                    tripType: this.tripType_flight || '',
                    departureDate: this.convertToISOFormat(segment.departureDate?.value) || null,
                    returnDate: (this.tripType_flight == 'oneWay' || this.tripType_flight == 'multiCity') ? null : (segment.returnDate ? this.convertToISOFormat(segment.returnDate?.value) : null),
                    journeyStartCity: segment.startCity?.value || '',
                    journeyEndCity: segment.endCity?.value || '',
                    // Use the first segment's values for these fields
                    numberOfAdults: firstSegment.adults || 1,
                    numberOfChildren: firstSegment.children || 0,
                    numberOfToddler: firstSegment.child || 0,
                    travelClass: firstSegment.travelClass?.value || 'Economy/Premium',
                };
            }) : null,
        };

        this.userLayoutService.customPackageInquiry(payload).subscribe(
            (Response: any) => {
                if (Response.code === 1) {
                    $('#customizeSearch').modal('hide');

                    // Cleanup fallback after hiding
                    setTimeout(function () {
                        $('.modal-backdrop').remove();
                        $('body').removeClass('modal-open');
                    }, 500);

                    this.commonService.notifier.notify('success', "We have received your request. MyYatra360 team will reach out to you at the earliest.");
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error);
            }
        );
    }
    private createCitySegment(startCityValue: any = null, endCityValue: any = null, travelClassValue: any = 'Economy/Premium'): any {
        return {
            startCity: new FormControl('', Validators.required),
            endCity: new FormControl('', Validators.required),
            departureDate: new FormControl(null, Validators.required),
            returnDate: new FormControl(null),
            adults: 1,
            children: 0,
            child: 0,
            travelClass: new FormControl('Economy/Premium', Validators.required)
        };
    }
    get personError() {
        let adults = parseInt(this.customInqForm.value.adults);
        let children = parseInt(this.customInqForm.value.children);

        if ((adults + children) == 0) {
            this.noOfPersonError = "Atleast 1 traveler required.";
            return true
        } else if (children > 0 && adults == 0) {
            this.noOfPersonError = "Atleast 1 Adult required."
            return true
        } else {
            this.noOfPersonError = ""
            return false
        }
    }

    convertToISOFormat(dateString: string): string {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            throw new Error("Invalid date string provided.");
        }

        return date.toISOString();
    }
    mobilenumberInputforpackage(event: any): void {
        const input = event.target;

        input.value = input.value.replace(/[^0-9]/g, '');

        this.customInqForm.patchValue({
            phoneNumber: input.value || null,
        });
    }
    onEndDateChange(date: any) {

        const startDate = this.customInqForm.get('startDate')?.value;
        this.customInqForm.get('endDate')?.setValue(date);
        const endDate = this.customInqForm.get('endDate')?.value;
        // console.log(startDate, endDate)

        if (startDate) {
            this.endDateBeforeStartDate = true;
        } else {
            this.endDateBeforeStartDate = false;
            this.customInqForm.get('endDate')?.setValue(null);
        }
    }

    increaseCountforpreferencepackage(category: string): void {
        const currentValue = this.customInqForm.get(category)?.value || 0;
        this.customInqForm.get(category)?.setValue(currentValue + 1);
    }

    decreaseCountforpreferencepackage(category: string): void {
        const currentValue = this.customInqForm.get(category)?.value || 0;
        if (currentValue > 0) {
            this.customInqForm.get(category)?.setValue(currentValue - 1);
        }
    }

    increaseCountchild(type: string, isToddler: boolean): void {
        if (type === 'children' || type === 'child') {
            const currentChildren = this.customInqForm.get('children')?.value || 0;
            const currentToddlers = this.customInqForm.get('child')?.value || 0;
            let childControl;
            // Increase the appropriate counter
            if (isToddler) {
                this.customInqForm.get('child')?.setValue(currentToddlers + 1);
                childControl = this.fb.group({
                    age: ['', [Validators.required, Validators.min(0), Validators.max(4)]],
                    isToddler: [isToddler]
                });
            } else {
                this.customInqForm.get('children')?.setValue(currentChildren + 1);
                childControl = this.fb.group({
                    age: ['', [Validators.required, Validators.min(5), Validators.max(11)]],
                    isToddler: [isToddler]
                });
            }

            (this.customInqForm.get('childAges') as FormArray).push(childControl);
        }
        // console.log(this.customInqForm.value);
    }

    decreaseCountchild(type: string, isToddler: boolean): void {
        if (type === 'children' || type === 'child') {
            const currentChildren = this.customInqForm.get('children')?.value || 0;
            const currentToddlers = this.customInqForm.get('child')?.value || 0;

            // Decrease the appropriate counter
            if (isToddler && currentToddlers > 0) {
                this.customInqForm.get('child')?.setValue(currentToddlers - 1);
            } else if (!isToddler && currentChildren > 0) {
                this.customInqForm.get('children')?.setValue(currentChildren - 1);
            }

            // Remove the last control from childAges FormArray based on isToddler
            const childAgesArray = this.customInqForm.get('childAges') as FormArray;

            // Loop through the array to find and remove the correct control based on 'isToddler'
            for (let i = childAgesArray.length - 1; i >= 0; i--) {
                const control = childAgesArray.at(i);
                if (control.get('isToddler')?.value === isToddler) {
                    childAgesArray.removeAt(i);
                    break;  // Exit the loop once the matching control is removed
                }
            }
        }
    }
    getChildrenControls() {
        return (this.customInqForm.get('childAges') as FormArray).controls.filter(control => !control.get('isToddler')?.value);
    }
    getToddlersControls() {
        return (this.customInqForm.get('childAges') as FormArray).controls.filter(control => control.get('isToddler')?.value);
    }
    getPlaceListData() {
        this.userLayoutService.getPlaceList().subscribe((Response: any) => {
            if (Response.code == 1) {
                this.PlaceList = Response.data;
            }
            else {
                console.warn("Failed to retrieve category details");
            }
        }, (error) => {
            console.error("Error fetching category details:", error.error.Message);
        });
    } // Flight-related functions
    flight_onStartDateChange(event: Date) {
        if (event) {
            this.minEndDate = new Date(event);
            this.minEndDate.setDate(this.minEndDate.getDate() + 1);
            this.endDateBeforeStartDate = true;
        }
    }

    flight_onEndDateChange(event: Date) {
        if (event && this.citySegments_flight[0].departureDate.value) {
            this.endDateBeforeStartDate = event >= this.citySegments_flight[0].departureDate.value;
        }
    }
    flight_decreaseCountChild(type: string, isToddler: boolean): void {
        const segment = this.citySegments_flight[0];
        if (isToddler && segment.child > 0) {
            segment.child--;
            segment.toddlerAges.removeAt(segment.toddlerAges.length - 1);
        } else if (!isToddler && segment.children > 0) {
            segment.children--;
            segment.childrenAges.removeAt(segment.childrenAges.length - 1);
        }
    }
    flight_increaseCountChild(type: string, isToddler: boolean): void {
        const segment = this.citySegments_flight[0];
        if (isToddler) {
            segment.child++;
            segment.toddlerAges.push(this.fb.group({ age: [null, [Validators.required, Validators.min(0), Validators.max(4)]] }));
        } else {
            segment.children++;
            segment.childrenAges.push(this.fb.group({ age: [null, [Validators.required, Validators.min(5), Validators.max(11)]] }));
        }
    }
    flight_increaseCount(type: string): void {
        if (type === 'adults_flight') {
            this.citySegments_flight[0].adults++;
        }
    }
    flight_decreaseCount(type: string): void {
        if (type === 'adults_flight' && this.citySegments_flight[0].adults > 1) {
            this.citySegments_flight[0].adults--;
        }
    }
    getToddlersControls_flight(): FormArray {
        return this.citySegments_flight[0].toddlerAges as FormArray;
    }
    flight_onSegmentStartDateChange(event: Date, index: number) {
        // Implement logic for multi-city date changes
    }
    getChildrenControls_flight(): FormArray {
        return this.citySegments_flight[0].childrenAges as FormArray;
    }
    flight_onTripTypeChange() {
        if (this.tripType_flight === 'round') {
            if (this.citySegments_flight.length > 1) {
                this.citySegments_flight = [this.citySegments_flight[0]];
            }
            this.citySegments_flight[0].returnDate.enable();
        } else if (this.tripType_flight === 'oneWay') {
            if (this.citySegments_flight.length > 1) {
                this.citySegments_flight = [this.citySegments_flight[0]];
            }
            this.citySegments_flight[0].returnDate.disable();
            this.citySegments_flight[0].returnDate.reset();
        } else if (this.tripType_flight === 'multiCity') {
            if (this.citySegments_flight.length === 1) {
                this.flight_addCitySegment();
            }
        }
    }

    flight_addCitySegment(): void {
        this.citySegments_flight.push({
            startCity: new FormControl(null, Validators.required),
            endCity: new FormControl(null, Validators.required),
            departureDate: new FormControl(null, Validators.required),
            returnDate: new FormControl(null),
            adults: 1,
            children: 0,
            child: 0,
            travelClass: 'Economy/Premium',
            childrenAges: this.fb.array([]),
            toddlerAges: this.fb.array([])
        });
    }

    flight_removeCitySegment(index: number): void {
        this.citySegments_flight.splice(index, 1);
    }

    updatecustomInqForm() {
        const city = this.bookingForm.get('arrivalCity')?.value;
        const places = this.overviewDataList?.places;
        const adults = this.rooms[0].adults;
        const child = this.rooms[0].child;
        const children = this.rooms[0].children;
        this.customInqForm.get('startCity').setValue(city)
        this.customInqForm.get('startDate').setValue(this.selectedStartDate)
        this.customInqForm.get('endDate').setValue(this.selectedEndDate)
        this.customInqForm.get('placeName').setValue(places);
        this.customInqForm.get('adults').setValue(adults);
        this.customInqForm.get('child').setValue(child);
        this.customInqForm.get('children').setValue(children);
        let comment = '';

        this.itineraryDataList.forEach((dayItem, index) => {
            // Add Day + Includes line
            comment += `Day ${dayItem.days}: ${dayItem.includes || ''}\n`;

            // Loop through vehicle/sub data
            if (Array.isArray(dayItem.homePackageDetailsItinerarySubDataData)) {
                dayItem.homePackageDetailsItinerarySubDataData.forEach((subItem) => {
                    if (subItem.carPickUp) {
                        comment += `${subItem.carPickUp}\n`;
                    }
                    if (subItem.hotelCheckIn) {
                        comment += `${subItem.hotelCheckIn}\n`;
                    }
                });
            }

            // Optional: add an empty line between days
            comment += '\n';
        });
        this.customInqForm.get('comments').setValue(comment);

    }

    //#endregion
}
